export function gaspScrolltrigger() {


    const wrapper = document.querySelector(".js-companyMsgImg");
    if (wrapper) {
        //読み込み
        gsap.registerPlugin(ScrollTrigger);
        //
        ScrollTrigger.normalizeScroll(true);

        //アニメーションエリア
        const trigger = document.querySelector('.js-companyMsgImg');

        //pin
        const tl = gsap.timeline({
            scrollTrigger: {
            trigger: trigger,
            start: "top top",
            end: "bottom top",
            //markers: true,
            scrub: 1,
            //pin: true,
            invalidateOnRefresh: true // これでリフレッシュ時にendを再計算
            }
        });

        tl
        .to(".p-companyMsg_body_cover_img._01",{delay: 3, autoAlpha: 0, duration: 2, ease: "power2.out" }, ">")
        .to(".p-companyMsg_body_cover_img._02",{delay: 3, autoAlpha: 0, duration: 2, ease: "power2.out" }, ">")
        .to(".p-companyMsg_body_cover_img._03",{delay: 3, autoAlpha: 1, duration: 2, ease: "power2.out" }, ">")
    }




    const interviewContBox = document.querySelector(".p-interviewCont_box_R");
    const parentBox = document.querySelector(".p-interviewCont_box");

    if (interviewContBox && parentBox) {
        gsap.registerPlugin(ScrollTrigger);
        ScrollTrigger.normalizeScroll(true);

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: interviewContBox,
                start: "top top",
                endTrigger: parentBox,  // end は親要素の位置で判定
                end: "bottom bottom",   // 親の bottom が viewport の bottom に到達時解除
                scrub: true,
                pin: true,
                invalidateOnRefresh: true,
                //markers: true,
            }
        });

        tl
        .set(".p-interviewCont_box_img._02", {autoAlpha: 0})
        .set(".p-interviewCont_box_img._03", {autoAlpha: 0})
        .to(".p-interviewCont_box_img._01",{delay: 8, autoAlpha: 0, duration: 3, ease: "power2.out" }, ">")
        .to(".p-interviewCont_box_img._02",{ autoAlpha: 1, duration: 3, ease: "power2.out" }, "<")
        .to(".p-interviewCont_box_img._02",{delay: 8, autoAlpha: 0, duration: 3, ease: "power2.out" }, ">")
        .to(".p-interviewCont_box_img._03",{ autoAlpha: 1, duration: 3, ease: "power2.out" }, "<")
    }


}
